import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addCapacityAssessmentType } from "common/services/capacity-assessments.service";
import Form from "./Form";
import { toast } from "react-toastify";

const AddCapacityAssessmentType: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          name: values["name"],
        },
      };

      setLoading(true);
      try {
        await addCapacityAssessmentType(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Capacity assessment type added successfully", {});
      } catch (e: any) {
        toast.error("Capacity assessment type creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Capacity Assessment Type
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddCapacityAssessmentType;
